import { useFormikContext } from "formik";
import React, { FC } from "react";
import { REPORTS_FILTER_DATE_TIME_DATE_RANGE, REPORTS_FILTER_DATE_TIME_SPECIFIC_DATE } from "../../../constants/element-type";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { getFormattedDate } from "../../../services/utilities/dateFormatting";
import { convertDateToNumber } from "../../../utilities/DateUtils";

interface SummaryProps {
    onBack: (event: any) => void;
    type: any,
    category: any
}

export const Summary: FC<SummaryProps> = ({ onBack, type, category }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext<any>();

    const getDateDetails = () => {
        let date: string = "";
        if (values.startDate && values.endDate && values.categoryElementSysname !== REPORTS_FILTER_DATE_TIME_SPECIFIC_DATE) {
            date = getFormattedDate(convertDateToNumber(values.startDate).toString()) + " - " + getFormattedDate(convertDateToNumber(values.endDate).toString())
        }
        else if (values.startDate) {
            date = getFormattedDate(convertDateToNumber(values.startDate).toString());
        }

        return <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.details)}: <span className="text-sm text-black">{date}</span></h4>
    }

    return <div className="flex flex-col pt-3 pr-3 h-full relative" style={{ height: "501px" }}>
        <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.summary)}</h2>
        <br />
        <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.filter)}: <span className="text-sm text-black">{type}</span></h4>
        <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.category)}: <span className="text-sm text-black">{category}</span></h4>
        {values.categoryElementSysname === REPORTS_FILTER_DATE_TIME_SPECIFIC_DATE || values.categoryElementSysname === REPORTS_FILTER_DATE_TIME_DATE_RANGE ? getDateDetails() : null}

        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className={`secondary secondary-inverse py-1 px-5`}
                    type="button"
                    onClick={onBack}>
                    {translate.byKey(TranslationKeys.back)}
                </button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary secondary-enabled`}
                    type={'submit'}>
                    {translate.byKey(TranslationKeys.submit)}
                </button>
            </div>
        </div>
    </div>
}
